import Show from 'containers/OrdersTabTryBuy/Show';
import List from 'containers/OrdersTabTryBuy/List';

export default { List, Show };
